export default __webpack_public_path__ + "static/media/client-9.f56f100c.png";